// extracted by mini-css-extract-plugin
export var submit = "FormSubmit-module--submit--a4525";
export var withNDA = "FormSubmit-module--withNDA--20704";
export var buttonWrap = "FormSubmit-module--buttonWrap--f2ff1";
export var ndaField = "FormSubmit-module--ndaField--00554";
export var button = "FormSubmit-module--button--26e3e";